(() => {
  console.log('[DA DIR] da-directional.js loaded');

  function findDirectionalBoxes() {
    return document.querySelectorAll('.da-dir-wrap[data-directional]');
  }

  function getPurchaseType(box) {
    const checked = box.querySelector('input[type="radio"]:checked');
    return checked ? String(checked.value || '').trim() : 'replacement';
  }

  function getCurrentVariantId(box) {
    const fromBox = parseInt(box.dataset.currentVariantId || '', 10);
    if (fromBox) return fromBox;
    const metaId = window.ShopifyAnalytics?.meta?.selectedVariantId;
    if (metaId) return parseInt(metaId, 10);
    const prod = window.meta?.product;
    return prod?.selected_or_first_available_variant?.id || null;
  }

  function getPairVariantId(box) {
    const v = parseInt(box.dataset.directionalPairVariantId || '', 10);
    return v || null;
  }

  function getDirectionalSide(box) {
    const raw = (box.getAttribute('data-directional-side') || '').trim();
    if (!raw) return 'Selected';
    return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
  }

  function getOppositeSide(side) {
    if (side.toLowerCase() === 'right') return 'Left';
    if (side.toLowerCase() === 'left') return 'Right';
    return 'Selected';
  }

  function buildItems(purchaseType, currentVariantId, pairVariantId) {
    switch (purchaseType) {
      case 'replacement':       return [{ id: currentVariantId, quantity: 1 }];
      case 'pair_same_current': return [{ id: currentVariantId, quantity: 2 }];
      case 'pair_mixed':        return [{ id: currentVariantId, quantity: 1 }, { id: pairVariantId, quantity: 1 }];
      case 'full_set':          return [{ id: currentVariantId, quantity: 2 }, { id: pairVariantId, quantity: 2 }];
      default:                  return null;
    }
  }

  async function clearVariantsFromCart(variantIds) {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      const updates = {};
      for (const item of cart.items) {
        if (variantIds.includes(item.variant_id)) updates[item.key] = 0;
      }
      if (Object.keys(updates).length === 0) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    } catch (err) {
      console.error('[DA DIR] clearVariantsFromCart error:', err);
    }
  }

  async function testVariant(variantId, variantIds) {
    try {
      await clearVariantsFromCart(variantIds);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 2 }] })
      });
      const text = await res.text();
      await clearVariantsFromCart(variantIds);
      const msg = text.toUpperCase();
      if (msg.includes('ONLY 1 ITEM WAS ADDED') || msg.includes('DUE TO AVAILABILITY')) return 'low_inventory';
      if (msg.includes('SOLD OUT') || msg.includes('OUT OF STOCK') || msg.includes('ALREADY SOLD OUT')) return 'out_of_stock';
      if (res.ok) return 'ok';
      return 'out_of_stock';
    } catch (err) {
      await clearVariantsFromCart(variantIds);
      return 'out_of_stock';
    }
  }

  function buildIssueMessage(issues) {
    const lines = issues.map(issue => {
      if (issue.type === 'out_of_stock') return `The ${issue.side.toLowerCase()} wheel is out of stock.`;
      return `Only 1 ${issue.side.toLowerCase()} wheel is in stock but you need 2.`;
    });
    return lines.join('\n');
  }

  function buildReducedItems(items, issues) {
    return items.map(item => {
      const issue = issues.find(i => i.variantId === item.id);
      if (!issue) return item;
      if (issue.type === 'out_of_stock') return null;
      if (issue.type === 'low_inventory') return { ...item, quantity: 1 };
      return item;
    }).filter(Boolean);
  }

  function showInventoryPopup(message, onConfirm, confirmLabel) {
    const existing = document.querySelector('.wheel-restriction-popup');
    if (existing) existing.remove();

    const previouslyFocused = document.activeElement;

    const wrapper = document.createElement('div');
    wrapper.className = 'wheel-restriction-popup';

    const overlay = document.createElement('div');
    overlay.className = 'wheel-restriction-overlay';

    const modal = document.createElement('div');
    modal.className = 'wheel-restriction-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'wheel-restriction-title');
    modal.setAttribute('tabindex', '-1');

    const srTitle = document.createElement('h2');
    srTitle.id = 'wheel-restriction-title';
    srTitle.textContent = 'Attention';
    srTitle.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;';
    modal.appendChild(srTitle);

    const content = document.createElement('div');
    content.className = 'wheel-restriction-content';
    content.style.cssText = 'text-align:center;';

    const lines = message.split('\n');
    lines.forEach((line, i) => {
      const p = document.createElement('p');
      p.style.cssText = i < lines.length - 1 ? 'margin:0 0 8px 0;' : 'margin:0 0 16px 0;';
      p.textContent = line;
      content.appendChild(p);
    });

    if (onConfirm) {
      const yesBtn = document.createElement('button');
      yesBtn.type = 'button';
      yesBtn.className = 'wheel-restriction-notify-btn';
      yesBtn.style.cssText = 'color:#b1081c; font-weight:600; text-decoration:underline; background:none; border:none; cursor:pointer; padding:0; margin-bottom:12px; font-size:inherit; display:block; text-align:center; width:100%;';
      yesBtn.textContent = confirmLabel || "Yes, Add What's Available to Cart";
      yesBtn.addEventListener('click', () => { cleanup(); onConfirm(); });
      content.appendChild(yesBtn);
    }

    const notifyBtn = document.createElement('button');
    notifyBtn.type = 'button';
    notifyBtn.className = 'wheel-restriction-notify-btn';
    notifyBtn.style.cssText = 'color:#b1081c; font-weight:600; text-decoration:underline; background:none; border:none; cursor:pointer; padding:0; margin-bottom:20px; font-size:inherit; display:block; text-align:center; width:100%;';
    notifyBtn.textContent = 'Notify Me When More Are Available';
    notifyBtn.addEventListener('click', () => {
      cleanup();
      const existingNotifyBtn = document.querySelector('.js-notify-me-button');
      if (existingNotifyBtn) existingNotifyBtn.click();
    });
    content.appendChild(notifyBtn);

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'wheel-restriction-close';
    closeBtn.style.cssText = 'margin-top:8px;';
    closeBtn.textContent = 'No, Take Me Back';
    closeBtn.setAttribute('aria-label', 'Close dialog and return to product page');
    closeBtn.addEventListener('click', cleanup);

    overlay.addEventListener('click', cleanup);

    modal.appendChild(content);
    modal.appendChild(closeBtn);
    wrapper.appendChild(overlay);
    wrapper.appendChild(modal);
    document.body.appendChild(wrapper);

    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    if (firstFocusable) firstFocusable.focus();

    function handleKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        cleanup();
        return;
      }
      if (e.key === 'Tab') {
        if (focusableElements.length === 0) {
          e.preventDefault();
          return;
        }
        if (e.shiftKey && document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        } else if (!e.shiftKey && document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
    document.addEventListener('keydown', handleKeydown);

    function cleanup() {
      document.removeEventListener('keydown', handleKeydown);
      wrapper.remove();
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    }
  }

  async function addItems(items, properties) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(i => ({ ...i, properties })) })
    });
    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(errorText);
    }
    return res.json();
  }

  function setBtnLoading(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.classList.toggle('is-loading', on);
  }

  async function handleAddToCart(box, btn) {
    const purchaseType = getPurchaseType(box);
    const currentVariantId = getCurrentVariantId(box);
    const pairVariantId = getPairVariantId(box);

    const items = buildItems(purchaseType, currentVariantId, pairVariantId);
    if (!items) return;

    setBtnLoading(btn, true);

    const currentSide = getDirectionalSide(box);
    const pairSide = getOppositeSide(currentSide);

    const props = {
      _purchase_type: purchaseType,
      _directional_side: currentSide,
      _directional_pair_variant_id: pairVariantId ? String(pairVariantId) : ''
    };

    const variantIds = [currentVariantId, pairVariantId].filter(Boolean);

    try {
      if (purchaseType === 'replacement') {
        await addItems(items, props);
        window.location.href = '/cart';
        return;
      }

      await clearVariantsFromCart(variantIds);
      await addItems(items, props);
      window.location.href = '/cart';

    } catch (err) {
      console.error('[DA DIR] addItems failed:', err);
      await clearVariantsFromCart(variantIds);

      if (purchaseType === 'full_set') {
        const currentStatus = await testVariant(currentVariantId, variantIds);
        const pairStatus = await testVariant(pairVariantId, variantIds);
        await clearVariantsFromCart(variantIds);

        const issues = [];
        if (currentStatus !== 'ok') issues.push({ side: currentSide, type: currentStatus, variantId: currentVariantId });
        if (pairStatus !== 'ok') issues.push({ side: pairSide, type: pairStatus, variantId: pairVariantId });

        if (issues.length === 0) {
          await addItems(items, props);
          window.location.href = '/cart';
          return;
        }

        const reducedItems = buildReducedItems(items, issues);
        const canAdd = reducedItems.length > 0;
        let confirmLabel = null;
        if (canAdd) {
          const allLow = issues.every(i => i.type === 'low_inventory');
          confirmLabel = allLow ? 'Yes, Add 1 of Each to Cart' : "Yes, Add What's Available to Cart";
        }

        showInventoryPopup(
          buildIssueMessage(issues),
          canAdd ? async () => {
            try {
              await clearVariantsFromCart(variantIds);
              await addItems(reducedItems, props);
              window.location.href = '/cart';
            } catch (retryErr) {
              console.error('[DA DIR] addItems (reduced full_set) failed:', retryErr);
            }
          } : null,
          confirmLabel
        );

      } else {
        let errorData = {};
        try { errorData = JSON.parse(err.message); } catch (_) {}
        const rawMessage = errorData?.description || errorData?.message || err.message || '';
        const msg = rawMessage.toUpperCase();

        if (msg.includes('ONLY 1 ITEM WAS ADDED') || msg.includes('DUE TO AVAILABILITY')) {
          const lowStockItem = items.find(i => i.quantity === 2);
          const lowStockVariantId = lowStockItem?.id;
          const side = lowStockVariantId === currentVariantId ? currentSide : pairSide;

          showInventoryPopup(
            `Only 1 ${side.toLowerCase()} wheel is in stock but you need 2. Would you like to add 1 to your cart anyway?`,
            async () => {
              try {
                await clearVariantsFromCart(variantIds);
                const reducedItems = items.map(i =>
                  i.id === lowStockVariantId ? { ...i, quantity: 1 } : i
                );
                await addItems(reducedItems, props);
                window.location.href = '/cart';
              } catch (retryErr) {
                console.error('[DA DIR] addItems (reduced) failed:', retryErr);
              }
            },
            'Yes, Add 1 to Cart'
          );

        } else {
          const t = rawMessage.toUpperCase();
          let side = 'Selected';
          if (t.includes('-LEFT') || t.includes('LEFT WHEEL') || t.includes('LEFT-')) side = 'Left';
          else if (t.includes('-RIGHT') || t.includes('RIGHT WHEEL') || t.includes('RIGHT-')) side = 'Right';
          showInventoryPopup(`Unfortunately the ${side.toLowerCase()} wheel is out of stock.`, null, null);
        }
      }

    } finally {
      setBtnLoading(btn, false);
    }
  }

  function init() {
    findDirectionalBoxes().forEach(box => {
      if (box.dataset.daDirCartInit === '1') return;
      box.dataset.daDirCartInit = '1';

      const cta = box.querySelector('[data-dir-cta]');
      if (!cta) return;

      cta.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await handleAddToCart(box, cta);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Back/forward navigation fix — refresh page to sync cart state
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
      return;
    }
    try {
      const nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') {
        window.location.reload();
      }
    } catch (e) {}
  });
})();